import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const disclaimerTranslations = {
  en: "Standard messaging rates may apply",
  ar: "\u0642\u062f \u064a\u062a\u0645 \u062a\u0637\u0628\u064a\u0642 \u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u0631\u0633\u0627\u0626\u0644 \u0627\u0644\u0642\u064a\u0627\u0633\u064a\u0629",
  bg: "\u041c\u043e\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043f\u0440\u0438\u043b\u0430\u0433\u0430\u0442 \u0441\u0442\u0430\u043d\u0434\u0430\u0440\u0442\u043d\u0438 \u0442\u0430\u0440\u0438\u0444\u0438 \u0437\u0430 \u0441\u044a\u043e\u0431\u0449\u0435\u043d\u0438\u044f",
  bs: "Mogu se primijeniti standardne cijene poruka",
  cs: "Mohou b\u00fdt \u00fa\u010dtov\u00e1ny standardn\u00ed sazby za zpr\u00e1vy",
  da: "Standard beskedtakster kan forekomme",
  de: "Es k\u00f6nnen Standard-Nachrichtentarife anfallen",
  el: "\u0395\u03bd\u03b4\u03ad\u03c7\u03b5\u03c4\u03b1\u03b9 \u03bd\u03b1 \u03b9\u03c3\u03c7\u03cd\u03bf\u03c5\u03bd \u03c4\u03c5\u03c0\u03b9\u03ba\u03ad\u03c2 \u03c7\u03c1\u03b5\u03ce\u03c3\u03b5\u03b9\u03c2 \u03bc\u03b7\u03bd\u03c5\u03bc\u03ac\u03c4\u03c9\u03bd",
  es: "Pueden aplicarse tarifas est\u00e1ndar de mensajer\u00eda",
  "es-419": "Pueden aplicarse tarifas est\u00e1ndar de mensajer\u00eda",
  et: "V\u00f5ivad kehtida tavap\u00e4rased s\u00f5numitasud",
  fa: "\u0646\u0631\u062e\u200c\u0647\u0627\u06cc \u0627\u0633\u062a\u0627\u0646\u062f\u0627\u0631\u062f \u067e\u06cc\u0627\u0645\u06a9 \u0645\u0645\u06a9\u0646 \u0627\u0633\u062a \u0627\u0639\u0645\u0627\u0644 \u0634\u0648\u062f",
  fi: "Vakioviestimaksut saattavat olla voimassa",
  fr: "Des frais de messagerie standard peuvent s\u2019appliquer",
  he: "\u05e2\u05e9\u05d5\u05d9\u05d9\u05dd \u05dc\u05d7\u05d5\u05dc \u05ea\u05e2\u05e8\u05d9\u05e4\u05d9 \u05d4\u05d5\u05d3\u05e2\u05d5\u05ea \u05e8\u05d2\u05d9\u05dc\u05d9\u05dd",
  hi: "\u092e\u093e\u0928\u0915 \u0938\u0902\u0926\u0947\u0936 \u0926\u0930\u0947\u0902 \u0932\u093e\u0917\u0942 \u0939\u094b \u0938\u0915\u0924\u0940 \u0939\u0948\u0902",
  hr: "Mogu se primijeniti standardne cijene poruka",
  hu: "Norm\u00e1l \u00fczenetk\u00fcld\u00e9si d\u00edjak \u00e9rv\u00e9nyesek lehetnek",
  hy: "\u053f\u0561\u0580\u0578\u0572 \u0565\u0576 \u056f\u056b\u0580\u0561\u057c\u057e\u0565\u056c \u0570\u0561\u0572\u0578\u0580\u0564\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056b \u057d\u057f\u0561\u0576\u0564\u0561\u0580\u057f \u057d\u0561\u056f\u0561\u0563\u0576\u0565\u0580",
  id: "Tarif pesan standar mungkin berlaku",
  it: "Potrebbero essere applicate le tariffe standard per i messaggi",
  ja: "\u6a19\u6e96\u306e\u30e1\u30c3\u30bb\u30fc\u30b8\u6599\u91d1\u304c\u304b\u304b\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059",
  ko: "\ud45c\uc900 \ubb38\uc790 \uba54\uc2dc\uc9c0 \uc694\uae08\uc774 \ubd80\uacfc\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4",
  lt: "Gali b\u016bti taikomi standartiniai \u017einu\u010di\u0173 tarifai",
  lv: "Var tikt piem\u0113roti standarta zi\u0146ojumu tarifi",
  mk: "\u041c\u043e\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043f\u0440\u0438\u043c\u0435\u043d\u0443\u0432\u0430\u0430\u0442 \u0441\u0442\u0430\u043d\u0434\u0430\u0440\u0434\u043d\u0438 \u0442\u0430\u0440\u0438\u0444\u0438 \u0437\u0430 \u043f\u043e\u0440\u0430\u043a\u0438",
  ms: "Kadar pemesejan standard mungkin dikenakan",
  nb: "Standard meldingspriser kan gjelde",
  nl: "Standaard berichttarieven kunnen van toepassing zijn",
  pl: "Mog\u0105 obowi\u0105zywa\u0107 standardowe op\u0142aty za wiadomo\u015bci",
  pt: "Podem aplicar-se tarifas de mensagens padr\u00e3o",
  "pt-BR": "Taxas padr\u00e3o de mensagens podem ser aplicadas",
  ro: "Se pot aplica tarife standard pentru mesaje",
  ru: "\u041c\u043e\u0433\u0443\u0442 \u043f\u0440\u0438\u043c\u0435\u043d\u044f\u0442\u044c\u0441\u044f \u0441\u0442\u0430\u043d\u0434\u0430\u0440\u0442\u043d\u044b\u0435 \u0442\u0430\u0440\u0438\u0444\u044b \u043d\u0430 \u0441\u043e\u043e\u0431\u0449\u0435\u043d\u0438\u044f",
  sk: "M\u00f4\u017eu sa \u00fa\u010dtova\u0165 \u0161tandardn\u00e9 sadzby za spr\u00e1vy",
  sq: "Mund t\u00eb aplikohen tarifat standarde t\u00eb mesazheve",
  "sr-RS": "\u041c\u043e\u0433\u0443 \u0441\u0435 \u043f\u0440\u0438\u043c\u0435\u043d\u0438\u0442\u0438 \u0441\u0442\u0430\u043d\u0434\u0430\u0440\u0434\u043d\u0435 \u0446\u0435\u043d\u0435 \u043f\u043e\u0440\u0443\u043a\u0430",
  "sr-Latn-RS": "Mogu se primeniti standardne cene poruka",
  sv: "Standardavgifter f\u00f6r meddelanden kan tillkomma",
  th: "\u0e2d\u0e32\u0e08\u0e21\u0e35\u0e04\u0e48\u0e32\u0e1a\u0e23\u0e34\u0e01\u0e32\u0e23\u0e2a\u0e48\u0e07\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e15\u0e32\u0e21\u0e2d\u0e31\u0e15\u0e23\u0e32\u0e1b\u0e01\u0e15\u0e34",
  tl: "Maaaring mag-apply ang mga karaniwang singil sa pagmemensahe",
  tr: "Standart mesaj \u00fccretleri uygulanabilir",
  uk: "\u041c\u043e\u0436\u0443\u0442\u044c \u0437\u0430\u0441\u0442\u043e\u0441\u043e\u0432\u0443\u0432\u0430\u0442\u0438\u0441\u044f \u0441\u0442\u0430\u043d\u0434\u0430\u0440\u0442\u043d\u0456 \u0442\u0430\u0440\u0438\u0444\u0438 \u043d\u0430 \u043f\u043e\u0432\u0456\u0434\u043e\u043c\u043b\u0435\u043d\u043d\u044f",
  ur: "\u0645\u0639\u06cc\u0627\u0631\u06cc \u067e\u06cc\u063a\u0627\u0645 \u0631\u0633\u0627\u0646\u06cc \u06a9\u06cc \u0634\u0631\u062d\u06cc\u06ba \u0644\u0627\u06af\u0648 \u06c1\u0648 \u0633\u06a9\u062a\u06cc \u06c1\u06cc\u06ba",
  vi: "C\u00f3 th\u1ec3 \u00e1p d\u1ee5ng ph\u00ed nh\u1eafn tin ti\u00eau chu\u1ea9n",
  zh: "\u53ef\u80fd\u4f1a\u6536\u53d6\u6807\u51c6\u77ed\u4fe1\u8d39\u7528",
};

const useMessagingDisclaimer = () => {
  const location = useLocation();

  const disclaimer = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const language = searchParams.get("language");
    const browserLanguage =
      typeof navigator !== "undefined" ? navigator.language : "";
    const effectiveLanguage = language || browserLanguage;

    if (!effectiveLanguage) {
      return disclaimerTranslations.en;
    }

    // Try exact match first (e.g., "pt-BR", "es-419")
    if (disclaimerTranslations[effectiveLanguage]) {
      return disclaimerTranslations[effectiveLanguage];
    }

    // Try base language (e.g., "en-US" -> "en")
    const baseLang = effectiveLanguage.split("-")[0].toLowerCase();
    if (disclaimerTranslations[baseLang]) {
      return disclaimerTranslations[baseLang];
    }

    // Fallback to English
    return disclaimerTranslations.en;
  }, [location.search]);

  return disclaimer;
};

export default useMessagingDisclaimer;
